module.exports = __webpack_public_path__ + "static/media/signin-background.21458cc5.jpg";